import { Link } from 'react-router'
import { ArrowLeft, Handshake, Building2, Wrench, ShoppingBag } from 'lucide-react'
import { Button } from '#app/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '#app/components/ui/card'

export default function PartnersPage() {
  const partnerCategories = [
    {
      title: 'Bouwbedrijven',
      icon: Building2,
      partners: ['BAM', 'Heijmans', 'VolkerWessels', 'Dura Vermeer'],
      description: 'Betrouwbare partners voor grote renovatieprojecten'
    },
    {
      title: 'Vakmensen',
      icon: Wrench,
      partners: ['Lokale aannemers', 'Installateurs', 'Elektriciens', 'Loodgieters'],
      description: 'Gecertificeerde professionals in je regio'
    },
    {
      title: 'Leveranciers',
      icon: ShoppingBag,
      partners: ['Praxis', 'Hornbach', 'Gamma', 'Karwei'],
      description: 'Materialen en producten voor elk project'
    }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/50">
      <div className="container mx-auto px-4 py-16 max-w-6xl">
        <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" />
          Terug naar home
        </Link>

        <div className="space-y-12">
          <div className="text-center space-y-4">
            <Handshake className="h-16 w-16 mx-auto text-primary" />
            <h1 className="text-4xl font-bold">Onze Partners</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Samen maken we renoveren toegankelijk voor iedereen
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {partnerCategories.map((category, index) => {
              const Icon = category.icon
              return (
                <Card key={index}>
                  <CardHeader>
                    <Icon className="h-10 w-10 text-primary mb-2" />
                    <CardTitle>{category.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground text-sm mb-4">{category.description}</p>
                    <ul className="space-y-1">
                      {category.partners.map((partner, idx) => (
                        <li key={idx} className="text-sm">• {partner}</li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              )
            })}
          </div>

          <div className="bg-primary/5 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Word Partner</h2>
            <p className="text-muted-foreground mb-6">
              Ben je een professional of bedrijf in de bouwsector? Sluit je aan bij ons netwerk
              en bereik duizenden huiseigenaren die klaar zijn voor renovatie.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild>
                <a href="mailto:partners@woonplan.nl">Contact Partnerships Team</a>
              </Button>
              <Button variant="outline" asChild>
                <Link to="/professionals">Voor Professionals</Link>
              </Button>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <Card>
              <CardHeader>
                <CardTitle>Voordelen voor Partners</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>✓ Toegang tot gekwalificeerde leads</li>
                  <li>✓ Geïntegreerde offertetool</li>
                  <li>✓ Project management platform</li>
                  <li>✓ Klantbeoordelingen & referenties</li>
                  <li>✓ Marketing ondersteuning</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Kwaliteitseisen</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>✓ Gecertificeerd & verzekerd</li>
                  <li>✓ Minimaal 3 jaar ervaring</li>
                  <li>✓ Positieve klantbeoordelingen</li>
                  <li>✓ Transparante prijzen</li>
                  <li>✓ Garantie op geleverd werk</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}